










































































































































































































































































































































































































































































import LazyHydrate from 'vue-lazy-hydration';
import { SfSelect, SfHeading, SfButton, SfLink } from '@storefront-ui/vue';
import { computed, defineComponent, onMounted, ref, ssrRef, useFetch, useRouter } from '@nuxtjs/composition-api';
import { CacheTagPrefix, useCache } from '@vue-storefront/cache';
import { usePageStore } from '~/stores/page';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import CategoryPagination from '~/modules/catalog/category/components/pagination/CategoryPagination.vue';
import { useCategory, useFacet, useUiHelpers, useUiState, } from '~/composables';
import { useAddToCart } from '~/helpers/cart/addToCart';
import { useWishlist } from '~/modules/wishlist/composables/useWishlist';
/* import { useComparelist } from '~/modules/comparelist/composables/useComparelist'; */
import { usePrice } from '~/modules/catalog/pricing/usePrice';
import { useCategoryContent } from '~/modules/catalog/category/components/cms/useCategoryContent';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import facetGetters from '~/modules/catalog/category/getters/facetGetters';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import CategoryNavbar from '~/modules/catalog/category/components/navbar/CategoryNavbar.vue';
import CategoryBreadcrumbs from '~/modules/catalog/category/components/breadcrumbs/CategoryBreadcrumbs.vue';
import type { ProductInterface } from '~/modules/GraphQL/types';
import type { SortingModel } from '~/modules/catalog/category/composables/useFacet/sortingOptions';
import type { Pagination } from '~/composables/types';
import type { Product } from '~/modules/catalog/product/types';
import SvgImage from '~/components/General/SvgImage.vue';
/* import { useComparelistStore } from '~/modules/comparelist/store/comparelistStore'; */
import type { ComparelistItemInterface } from '~/modules/GraphQL/types';
/* import CompareListBox from '~/components/ProductListPage/CompareListBox.vue' */

export default defineComponent({
  name: 'CategoryPage',
  components: {
    CategoryPagination,
    CategoryEmptyResults: () => import('~/modules/catalog/category/components/CategoryEmptyResults.vue'),
    CategoryFilters: () => import('~/modules/catalog/category/components/filters/CategoryFilters.vue'),
    CmsContent: () => import('~/modules/catalog/category/components/cms/CmsContent.vue'),
    CategoryProductGrid: () => import('~/modules/catalog/category/components/views/CategoryProductGrid.vue'),
    CategoryProductList: () => import('~/modules/catalog/category/components/views/CategoryProductList.vue'),
    CategoryNavbar,
    CategoryBreadcrumbs,
    SfSelect,
    LazyHydrate,
    SfHeading,
    SkeletonLoader,
    SfButton,
    SvgImage,
    SfLink,
    /* CompareListBox */
  },
  transition: 'fade',
  props: {
    routerDataRes: {
      type: Object,
      default: {}
    },
  },
  setup({ routerDataRes }) {
    const { routeData } = usePageStore();
    const { getContentData } = useCategoryContent();
    const { loadCategoryMeta } = useCategory();
    const { addTags } = useCache();
    const uiHelpers = useUiHelpers();
    const cmsContent = ref('');
    const isShowCms = ref(false);
    const isShowProducts = ref(false);
    const products = ssrRef<ProductInterface[]>([]);
    const sortBy = ref<SortingModel>({ selected: '', options: [] });
    const pagination = ref<Pagination>({});
    const productContainerElement = ref<HTMLElement | null>(null);
    const { toggleFilterSidebar, changeToCategoryListView, changeToCategoryGridView, isCategoryGridView, isFilterSidebarOpen, } = useUiState();
    const { load: loadWishlist, addItem: addItemToWishlistBase, isInWishlist, removeItem: removeItemFromWishlist, } = useWishlist();
    /* const { load: loadComparelist, addItem: addItemToComparelistBase, isInComparelist, removeItem: removeItemFromComparelist, removeItem } = useComparelist(); */
    const { result, search } = useFacet();
    const { addItemToCart } = useAddToCart();
    const categoryMeta = ref(null);
    const bgimage1Url = '/categorypage/camerasHeader.webp';

    const addItemToWishlist = async (product: Product) => {
      await (isInWishlist({ product }) ? removeItemFromWishlist({ product }) : addItemToWishlistBase({ product }));
    };

    /* const addItemToComparelist = async (product: Product) => {
      await (isInComparelist({ product }) ? removeItemFromComparelist({ product }) : addItemToComparelistBase({ product }));
    }; */

    const { activeCategory, loadCategoryTree } = useTraverseCategory();
    const activeCategoryName = computed(() => activeCategory.value?.name ?? cleanedFileName);
    const router = useRouter();
    const path = router.currentRoute?.path;
    const parts = path.split('/');
    const lastPart = parts[parts.length - 1]; // Select the last part of the array
    const fileName = lastPart.split('.')[0]; // Remove the file extension if present
    const cleanedFileName = fileName.replace(/-/g, ' '); // Remove all occurrences of '-'

    const categoryUid = (routeData != null && routeData.uid)? routeData.uid: routerDataRes.uid;

    const { fetch } = useFetch(async () => {
      if (!activeCategory.value) {
        await loadCategoryTree();
      }
      const [content, categoryMetaData] = await Promise.all([
        getContentData(categoryUid as string),
        loadCategoryMeta({ category_uid: categoryUid }),
        search({ ...uiHelpers.getFacetsFromURL(), category_uid: categoryUid }),
      ]);

      categoryMeta.value = categoryMetaData;
      cmsContent.value = content?.cmsBlock?.content ?? '';
      isShowCms.value = content.isShowCms;
      isShowProducts.value = content.isShowProducts;
      /* if(result.value.input.sort == null || result.value.input.sort == ''){
        result.value.input.sort = 'quantity_and_stock_status-DESC';
      } */
      products.value = facetGetters.getProducts(result.value) ?? [];
      sortBy.value = facetGetters.getSortOptions(result.value);
      pagination.value = facetGetters.getPagination(result.value);

      const tags = [{ prefix: CacheTagPrefix.View, value: (routeData != null && routeData.uid)? routeData.uid: routerDataRes.uid }];
      const productTags = products.value.map((product) => ({
        prefix: CacheTagPrefix.Product,
        value: product.uid,
      }));

      addTags([...tags, ...productTags]);
    });

    const isPriceLoaded = ref(false);

    onMounted(async () => {
      loadWishlist();
      /* loadComparelist(); */
      const { getPricesBySku } = usePrice();
      if (products.value.length > 0) {
        const skus = products.value.map((item) => item.sku);
        const priceData = await getPricesBySku(skus, pagination.value.itemsPerPage);
        products.value = products.value.map((product) => {
          const priceRange = priceData.items.find((item) => item.sku === product.sku)?.price_range;

          if (priceRange) {
            return {
              ...product,
              price_range: priceRange,
            };
          }

          return { ...product };
        });
      }

      isPriceLoaded.value = true;
    });

    const goToPage = (page: number) => {
      uiHelpers.changePage(page, false);
      fetch();      
      document.getElementById("layout").scrollIntoView();
    };

    const doChangeItemsPerPage = (itemsPerPage: number) => {
      uiHelpers.changeItemsPerPage(itemsPerPage, false);
      goToPage(0);
    };

    const onReloadProducts = () => {
      goToPage(0);
      productContainerElement.value.scrollIntoView();
    };

    const doChangeSorting = (sort: string) => {
      uiHelpers.changeSorting(sort, false);
      onReloadProducts();
    };

    /* const comparelistStore = useComparelistStore(); */

    /* const comparelistItems = computed<ComparelistItemInterface[]>(
      () => comparelistStore.comparelist?.items ?? [],
    ); */

    /* const removeCompareItem = (item) => {
      removeItemFromWishlist(item.product);
    }; */

    /* const removeAllCompareItems = () => {
      for (let index = 0; index < comparelistItems.value.length; index++) {
        const element = comparelistItems.value[index];
        //@ts-ignore
        removeItem({ product: element.product });
      }
    }; */

    const lenses_category_titlebar = {
      topBanner: '/categorypage/Lenses/Lenses00.webp',
      subCategory: [
        {
          image: '/categorypage/Lenses/Lenses01.webp',
          categoryUrl: '/photography/cameras-lenses/lenses/mirrorless-lenses.html'
        },
        {
          image: '/categorypage/Lenses/Lenses02.webp',
          categoryUrl: '/photography/cameras-lenses/lenses/slr-lenses.html'
        },
        {
          image: '/categorypage/Lenses/Lenses03.webp',
          categoryUrl: '/photography/cameras-lenses/lenses/medium-large-format-lenses.html'
        },
        {
          image: '/categorypage/Lenses/Lenses04.webp',
          categoryUrl: '/video/cine-cameras-lenses/cine-lenses.html'
        },
        {
          image: '/categorypage/Lenses/Lenses05.webp',
          categoryUrl: '/photography/cameras-lenses/lenses/special-effects-lenses.html'
        },
        {
          image: '/categorypage/Lenses/Lenses06.webp',
          categoryUrl: '/photography/accessories/lens-filters-accessories.html'
        },
        {
          image: '/categorypage/Lenses/Lenses07.webp',
          categoryUrl: '/photography/accessories/lens-accessories.html'
        },
      ]
    };

    const digital_cameras_category_titlebar = {
      topBanner: '/categorypage/camerasHeader.webp',
      subCategory: [
        {
          image: '/categorypage/01-Mirrorless.jpg',
          categoryUrl: '/photography/cameras-lenses/digital-cameras/mirrorless-system-cameras.html'
        },
        {
          image: '/categorypage/02-DSLR.jpg',
          categoryUrl: '/photography/cameras-lenses/digital-cameras/dslr-cameras.html'
        },
        {
          image: '/categorypage/03-PointAndShoot.jpg',
          categoryUrl: '/photography/cameras-lenses/digital-cameras/point-shoot-cameras.html'
        },
        {
          image: '/categorypage/04-MediumFormat.jpg',
          categoryUrl: '/photography/cameras-lenses/digital-cameras/medium-format-cameras.html'
        },
        {
          image: '/categorypage/05-FilmCameras.jpg',
          categoryUrl: '/photography/cameras-lenses/35mm-instant-film-cameras.html'
        },
        {
          image: '/categorypage/06-DisposableCameras.jpg',
          categoryUrl: '/photography/cameras-lenses/35mm-instant-film-cameras/disposable-cameras.html'
        },
      ]
    };

    const accessories_category_titlebar = {
      topBanner: '/categorypage/Accessories/Accessories00.webp',
      subCategory: [
        {
          image: '/categorypage/Accessories/Accessories01.webp',
          categoryUrl: '/photography/accessories/tripods-supports.html'
        },
        {
          image: '/categorypage/Accessories/Accessories02.webp',
          categoryUrl: '/photography/accessories/photography-bags-cases.html'
        },
        {
          image: '/categorypage/Accessories/Accessories03.webp',
          categoryUrl: '/photography/accessories/camera-straps.html'
        },
        {
          image: '/categorypage/Accessories/Accessories04.webp',
          categoryUrl: '/photography/accessories/batteries-power-accessories.html'
        },
        {
          image: '/categorypage/Accessories/Accessories05.webp',
          categoryUrl: '/photography/accessories/memory-cards-accessories.html'
        },
        {
          image: '/categorypage/Accessories/Accessories06.webp',
          categoryUrl: '/lighting-studio/continuous-strobe-lighting/flashes-on-camera-lighting.html'
        },
		    {
          image: '/categorypage/Accessories/Accessories07.webp',
          categoryUrl: '/photography/accessories/lens-filters-accessories.html'
        },
		    {
          image: '/categorypage/Accessories/Accessories08.webp',
          categoryUrl: '/photography/accessories/lens-accessories.html'
        },
      ]
    };

    const lighting_category_titlebar = {
      topBanner: '/categorypage/Lighting/Lighting00.webp',
      subCategory: [
        {
          image: '/categorypage/Lighting/Lighting01.webp',
          categoryUrl: '/lighting-studio/continuous-strobe-lighting/continuous-lighting.html'
        },
        {
          image: '/categorypage/Lighting/Lighting02.webp',
          categoryUrl: '/lighting-studio/continuous-strobe-lighting/strobe-lighting.html'
        },
        {
          image: '/categorypage/Lighting/Lighting03.webp',
          categoryUrl: '/lighting-studio/continuous-strobe-lighting/flashes-on-camera-lighting.html'
        },
        {
          image: '/categorypage/Lighting/Lighting04.webp',
          categoryUrl: '/lighting-studio/accessories/light-modifiers.html'
        },
        {
          image: '/categorypage/Lighting/Lighting05.webp',
          categoryUrl: '/lighting-studio/accessories/light-stands-mounting/light-stands.html'
        },
        {
          image: '/categorypage/Lighting/Lighting06.webp',
          categoryUrl: '/lighting-studio/accessories/lighting-radio-optical-triggering.html'
        },
		    {
          image: '/categorypage/Lighting/Lighting07.webp',
          categoryUrl: '/lighting-studio/accessories.html'
        },
		    {
          image: '/categorypage/Lighting/Lighting08.webp',
          categoryUrl: '/lighting-studio/studio-equipment.html'
        },
      ]
    };

    const audio_category_titlebar = {
      topBanner: '/categorypage/Audio/Audio00.webp',
      subCategory: [
        {
          image: '/categorypage/Audio/Audio01.webp',
          categoryUrl: '/audio/location-sound/wireless-microphones.html'
        },
		    {
          image: '/categorypage/Audio/Audio02.webp',
          categoryUrl: '#'
        },
        {
          image: '/categorypage/Audio/Audio03.webp',
          categoryUrl: '/audio/location-sound/wired-microphones.html'
        },
		    {
          image: '/categorypage/Audio/Audio04.webp',
          categoryUrl: '#'
        },
        {
          image: '/categorypage/Audio/Audio05.webp',
          categoryUrl: '/audio/audio-accessories/headphones.html'
        },
        {
          image: '/categorypage/Audio/Audio06.webp',
          categoryUrl: '/audio/audio-accessories.html'
        },
      ]
    };

    const video_category_titlebar = {
      topBanner: '/categorypage/Video/Video00.webp',
      subCategory: [
        {
          image: '/categorypage/Video/Video01.webp',
          categoryUrl: '/video/drones-aerial-imaging/drones.html'
        },
		    {
          image: '/categorypage/Video/Video02.webp',
          categoryUrl: '/video/cine-cameras-lenses/cine-cameras.html'
        },
        {
          image: '/categorypage/Video/Video03.webp',
          categoryUrl: '/video/cine-cameras-lenses/cine-lenses.html'
        },
        {
          image: '/categorypage/Video/Video04.webp',
          categoryUrl: '/video/action-cameras-accessories.html'
        },
        {
          image: '/categorypage/Video/Video05.webp',
          categoryUrl: '/video/video-streaming-gear.html'
        },
        {
          image: '/categorypage/Video/Video06.webp',
          categoryUrl: '/video/camcorders.html'
        },
		    {
          image: '/categorypage/Video/Video07.webp',
          categoryUrl: '/video/drones-aerial-imaging/drone-batteries-accessories.html'
        },
		    {
          image: '/categorypage/Video/Video08.webp',
          categoryUrl: '/video/cine-cameras-lenses/cine-accessories.html'
        },
      ]
    };

    const film_category_titlebar = {
      topBanner: '/categorypage/Film/Film00.webp',
      subCategory: [
        {
          image: '/categorypage/Film/StudentKits1.webp',
          categoryUrl: '/photography/film-darkroom-supplies/student-kits.html'
        },
        {
          image: '/categorypage/Film/Film01.webp',
          categoryUrl: '/photography/cameras-lenses/35mm-instant-film-cameras/35mm-film-cameras.html'
        },
		    {
          image: '/categorypage/Film/Film02.webp',
          categoryUrl: '/photography/cameras-lenses/35mm-instant-film-cameras/instant-film-cameras.html'
        },
        {
          image: '/categorypage/Film/Film03.webp',
          categoryUrl: '/photography/film-darkroom-supplies/film.html'
        },
		    {
          image: '/categorypage/Film/Film04.webp',
          categoryUrl: '/photography/film-darkroom-supplies/paper.html'
        },
        {
          image: '/categorypage/Film/Film05.webp',
          categoryUrl: '/photography/film-darkroom-supplies.html'
        },
      ]
    };

    const used_category_titlebar = {
      topBanner: '/categorypage/Used/Used00.webp',
      subCategory: [
        {
          image: '/categorypage/Used/Used01.webp',
          categoryUrl: '/used-equipment/used-cameras.html'
        },
		    {
          image: '/categorypage/Used/Used02.webp',
          categoryUrl: '/used-equipment/used-lenses.html'
        },
        {
          image: '/categorypage/Used/Used03.webp',
          categoryUrl: '/used-equipment/used-lighting.html'
        },
		    {
          image: '/categorypage/Used/Used04.webp',
          categoryUrl: '/used-equipment/used-audio-gear.html'
        },
        {
          image: '/categorypage/Used/Used05.webp',
          categoryUrl: '#'
        },
      ]
    };

    const scanning_printing_category_titlebar = {
      topBanner: '/categorypage/ScanningPrinting/ScanningPrinting00.webp',
      subCategory: [
        {
          image: '/categorypage/ScanningPrinting/ScanningPrinting01.webp',
          categoryUrl: '/photography/scanning-printing/photo-printers.html'
        },
		    {
          image: '/categorypage/ScanningPrinting/ScanningPrinting02.webp',
          categoryUrl: '#'
        },
		    {
          image: '/categorypage/ScanningPrinting/ScanningPrinting03.webp',
          categoryUrl: '/photography/scanning-printing/inkjet-ink-paper-supplies.html'
        },
        {
          image: '/categorypage/ScanningPrinting/ScanningPrinting04.webp',
          categoryUrl: '/photography/scanning-printing/scanners-accessories.html'
        },
		    {
          image: '/categorypage/ScanningPrinting/ScanningPrinting05.webp',
          categoryUrl: '/photography/scanning-printing/presentation-storage.html'
        },
        {
          image: '/categorypage/ScanningPrinting/ScanningPrinting06.webp',
          categoryUrl: '/photography/film-darkroom-supplies.html'
        },
      ]
    };

    const firstBannerUrl = computed(() => {
      try {
        if (activeCategoryName.value == 'Lenses' || activeCategoryName.value == 'Lens Accessories' || activeCategoryName.value == 'slr lenses' || activeCategoryName.value == 'mirrorless lenses' || activeCategoryName.value == 'medium large format lenses' || activeCategoryName.value == 'Cine Lenses' || activeCategoryName.value == 'special effects lenses' || activeCategoryName.value == 'Lens Filters & Accessories') {
          return (
            'https://mpex.com' + lenses_category_titlebar.topBanner ||
            null
          );
        } else if (activeCategoryName.value == 'Digital Cameras' || activeCategoryName.value == 'mirrorless system cameras' || activeCategoryName.value == 'dslr cameras' || activeCategoryName.value == 'point shoot cameras' || activeCategoryName.value == 'medium format cameras' || activeCategoryName.value == 'Film Cameras' || activeCategoryName.value == 'disposable cameras') {
          return (
            'https://mpex.com' + digital_cameras_category_titlebar.topBanner ||
            null
          );
        } else if (activeCategoryName.value == 'Accessories' || activeCategoryName.value == 'Tripods & Supports' || activeCategoryName.value == 'Photography Bags & Cases' || activeCategoryName.value == 'Camera Straps' || activeCategoryName.value == 'Batteries & Power Accessories' || activeCategoryName.value == 'Memory Cards & Accessories' || activeCategoryName.value == 'Flashes & On-Camera Lighting' || activeCategoryName.value == 'Lens Accessories') {
          return (
            'https://mpex.com' + accessories_category_titlebar.topBanner ||
            null
          );
        } else if (activeCategoryName.value == 'continuous lighting' || activeCategoryName.value == 'strobe lighting' || activeCategoryName.value == 'Flashes & On-Camera Lighting' || activeCategoryName.value == 'Light Modifiers' || activeCategoryName.value == 'light stands' || activeCategoryName.value == 'Lighting Radio & Optical Triggering' || activeCategoryName.value == 'Lighting Accessories' || activeCategoryName.value == 'Studio Equipment') {
          return (
            'https://mpex.com' + lighting_category_titlebar.topBanner ||
            null
          );
        } else if (activeCategoryName.value == 'Location Sound' || activeCategoryName.value == 'Wireless Microphones' || activeCategoryName.value == 'Wired Microphones' || activeCategoryName.value == 'Headphones' || activeCategoryName.value == 'Audio Accessories' || activeCategoryName.value == 'Microphones' || activeCategoryName.value == 'Mobile Recording') {
          return (
            'https://mpex.com' + audio_category_titlebar.topBanner ||
            null
          );
        } else if (activeCategoryName.value == 'Drones & Aerial Imaging' || activeCategoryName.value == 'Drones' || activeCategoryName.value == 'Cine Cameras' || activeCategoryName.value == 'Cine Lenses' || activeCategoryName.value == 'Action Cameras & Accessories' || activeCategoryName.value == 'Video Streaming Gear' || activeCategoryName.value == 'Camcorders & Professional Camcorders' || activeCategoryName.value == 'Drone Batteries & Accessories' || activeCategoryName.value == 'Cine Accessories' || activeCategoryName.value == 'Cine Accessories' || activeCategoryName.value == 'Cine Cameras & Lenses' || activeCategoryName.value == 'Production Equipment') {
          return (
            'https://mpex.com' + video_category_titlebar.topBanner ||
            null
          );
        } else if (activeCategoryName.value == 'Film & Darkroom Supplies' || activeCategoryName.value == '35mm film cameras' || activeCategoryName.value == 'instant film cameras' || activeCategoryName.value == 'Film' || activeCategoryName.value == 'Paper' || activeCategoryName.value == 'Film & Darkroom Supplies' || activeCategoryName.value == 'Student Kits') {
          return (
            'https://mpex.com' + film_category_titlebar.topBanner ||
            null
          );
        } else if (activeCategoryName.value == 'Used Cameras' || activeCategoryName.value == 'Used Lenses' || activeCategoryName.value == 'Used Lighting' || activeCategoryName.value == 'Used Audio Gear') {
          return (
            'https://mpex.com' + used_category_titlebar.topBanner ||
            null
          );
        } else if (activeCategoryName.value == 'Photo Printers' || activeCategoryName.value == 'Scanning & Printing' || activeCategoryName.value == 'Inkjet Ink & Paper Supplies' || activeCategoryName.value == 'Scanners & Accessories' || activeCategoryName.value == 'Presentation & Storage' || activeCategoryName.value == 'Film & Darkroom Supplies') {
          return (
            'https://mpex.com' + scanning_printing_category_titlebar.topBanner ||
            null
          );
        } else {
          return 'https://mpex.com' + digital_cameras_category_titlebar.topBanner ||
          null;
        }
      } catch {
        return null;
      }
    });

    return {
      isPriceLoaded,
      ...uiHelpers,
      toggleFilterSidebar,
      isCategoryGridView,
      changeToCategoryListView,
      changeToCategoryGridView,
      isFilterSidebarOpen,
      addItemToCart,
      addItemToWishlist,
      /* addItemToComparelist, */
      pagination,
      products,
      sortBy,
      isShowCms,
      isShowProducts,
      cmsContent,
      activeCategoryName,
      routeData,
      doChangeItemsPerPage,
      productContainerElement,
      categoryMeta,
      onReloadProducts,
      goToPage,
      doChangeSorting,
      bgimage1Url,
      /* removeAllCompareItems,
      removeCompareItem,
      comparelistItems,
      removeItem, */
      lenses_category_titlebar,
      digital_cameras_category_titlebar,
      accessories_category_titlebar,
      lighting_category_titlebar,
      audio_category_titlebar,
      video_category_titlebar,
      film_category_titlebar,
      used_category_titlebar,
      scanning_printing_category_titlebar,
      firstBannerUrl
    };
  },
  head() {
    return { 
      ...getMetaInfo(this.categoryMeta),
      link: this.firstBannerUrl
        ? [
            {
              hid: 'first-image-preload',
              rel: 'preload',
              as: 'image',
              href: this.firstBannerUrl
            }
          ]
        : []
    };
  },
});
